import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  path?: string;
}

function getBreadcrumbs(pathname: string): BreadcrumbItem[] {
  const items: BreadcrumbItem[] = [{ name: '首页', path: '/' }];

  if (pathname.startsWith('/category/')) {
    const slug = pathname.split('/')[2];
    const categoryNames: Record<string, string> = {
      'western-classical': '西方古典绘画',
      'eastern-art': '东方艺术',
      'modern-photography': '现代摄影',
      'sculpture': '雕塑艺术',
      'contemporary-art': '当代艺术',
    };
    items.push({ name: categoryNames[slug] || '分类', path: pathname });
  }

  if (pathname.startsWith('/article/')) {
    items.push({ name: '文章', path: pathname });
  }

  if (pathname === '/about') {
    items.push({ name: '关于我们', path: '/about' });
  }

  return items;
}

export default function Breadcrumb() {
  const location = useLocation();
  const breadcrumbs = getBreadcrumbs(location.pathname);

  if (breadcrumbs.length <= 1) return null;

  return (
    <nav aria-label="Breadcrumb" className="max-w-7xl mx-auto px-4 md:px-6 pt-24 pb-4">
      <ol
        className="flex flex-wrap items-center text-xs text-foreground-600"
        itemScope
        itemType="https://schema.org/BreadcrumbList"
      >
        {breadcrumbs.map((item, index) => {
          const isLast = index === breadcrumbs.length - 1;
          return (
            <li
              key={item.path || item.name}
              className="flex items-center"
              itemProp="itemListElement"
              itemScope
              itemType="https://schema.org/ListItem"
            >
              {isLast ? (
                <span
                  className="text-foreground-900 font-medium"
                  itemProp="name"
                >
                  {item.name}
                </span>
              ) : (
                <Link
                  to={item.path || '/'}
                  className="hover:text-primary-500 transition-colors duration-200"
                  itemProp="item"
                >
                  <span itemProp="name">{item.name}</span>
                </Link>
              )}
              <meta itemProp="position" content={String(index + 1)} />
              {!isLast && (
                <span className="mx-2 text-foreground-400">/</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}